import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import HelpBlock from './../../Layout/HelpBlock/HelpBlock';

import { toastrAdd } from '../../../actions/index';
import api from '../../../api/index';

function SupportModal(props) {
    const partnerID = localStorage.getItem('partnerID');
    const { eventID } = useSelector(state => state.event);
    const { data } = useSelector(state => state.user);;
    const { email } = data;
    const { t } = useTranslation();
    const [ sending, setSending ] = useState(false);
    const dispatch = useDispatch();

    const initialValues = {
        email,
        subject: 'ScanPoints',
        message: ''
    };

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            email: Yup.string().email(t('form.email_invalid')).required('form.email_required'),
            subject: Yup.string().required(t('form.subject_required')),
            message: Yup.string().required(t('form.message_required'))
        }),
        onSubmit: ({ email, subject, message }) => {
            setSending(true);

            api.support.sendSupportEmail(eventID, partnerID, {
                senderEmail: email,
                subject,
                content: message.replace(/(?:\r\n|\r|\n)/g, '<br>')
            })
                .then(() => {
                    dispatch(toastrAdd({
                        code: 0,
                        type: 'success',
                        title: t('instructions.support_email.support_request_success_title'),
                        details: t('instructions.support_email.support_request_success_details')
                    }));
                    setSending(false);
                    formik.setValues({ ...initialValues, email, subject }, false);
                })
                .catch(({ firstError }) => {
                    dispatch(toastrAdd({
                        code: 0,
                        type: 'error',
                        title: t('instructions.support_email.support_request_fail_title'),
                        details: `${t('general.details')}: ${firstError.title} - ${firstError.details}`
                    }));
                    setSending(false);
                });
        }
    });

    const { values, errors, touched } = formik;

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form onSubmit={formik.handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t('instructions.support_email.header')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <HelpBlock>
                        <span>{t('instructions.support_email.help_block')}</span>
                    </HelpBlock>
                    <Form.Group controlId="email">
                        <Form.Label>{t('general.emailAddress')}</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder={t('general.emailAddress')}
                            name="email"
                            value={values.email}
                            onChange={formik.handleChange}
                            isInvalid={errors.email && touched.email}
                        />
                    </Form.Group>
                    <Form.Group controlId="subject">
                        <Form.Label>{t('general.subject')}</Form.Label>
                        <Form.Control
                            as="select"
                            value={values.subject}
                            onChange={formik.handleChange}
                            isInvalid={errors.subject && touched.subject}
                            disabled={sending}
                        >
                            <option value="ScanPoints">{t('instructions.support_email.subject_scans')}</option>
                            <option value="Muu">{t('instructions.support_email.subject_other')}</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="message">
                        <Form.Label>{t('general.message')}</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={6}
                            value={values.message}
                            onChange={formik.handleChange}
                            disabled={sending}
                            isInvalid={errors.message && touched.message}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" variant="default" onClick={props.onHide}>{t('general.close')}</Button>
                    <Button type="submit" variant="primary" disabled={sending}>{t('general.send_message')}</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
};

export default SupportModal;